export const FLAG_IMG_BASE_URL = 'https://flagcdn.com';
